import { ROUTES } from "../../../setup/constants";

export const NAVBAR_ITEMS = [
  { label: "الرئيسية", route: ROUTES.HOME },
  { label: "معاملاتي", route: ROUTES.CONTRACTS_LIST },
  { label: "طلبات التسوية", route: ROUTES.SETTLEMENTS },
  { label: "كل المستخدمين", route: ROUTES.USERS_MANAGEMENT },
  { label: "إعدادات", route: ROUTES.SETTINGS },
];
export const BUTTONS = {
  LOGIN: "تسجيل الدخول",
  SIGNUP: "انشئ حسابك",
  LOGOUT: "تسجيل الخروج",
};
export const PROFILE_ITEMS = {
  SHOW_YOU_PROFILE: "عرض ملفك الشخصي",
  CHANGE_PIN_CODE: "تغيير رمز الامان",
};

export const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER;
